export const authenticate = (response: any, next: () => void) => {
    if (typeof window !== "undefined") {
        sessionStorage.setItem("thsl_token", JSON.stringify(response.data.result.token));
        sessionStorage.setItem("thsl_id", JSON.stringify(response.data.result.id));
        sessionStorage.setItem("thsl_user", JSON.stringify(response.data.result.name));
        sessionStorage.setItem("thsl_email", JSON.stringify(response.data.result.email));
    }
    next();
};

export const getToken = (): string | false => {
    if (typeof window !== "undefined") {
        const token = sessionStorage.getItem("thsl_token");
        if (token) {
            return JSON.parse(token);
        }
    }
    return false;
};

export const getUserName = (): string | false => {
    if (typeof window !== "undefined") {
        const user = sessionStorage.getItem("thsl_user");
        if (user) {
            return JSON.parse(user);
        }
    }
    return false;
};

export const getUserEmail = (): string | false => {
    if (typeof window !== "undefined") {
        const email = sessionStorage.getItem("thsl_email");
        if (email) {
            return JSON.parse(email);
        }
    }
    return false;
};

export const getUserID = (): string | false => {
    if (typeof window !== "undefined") {
        const id = sessionStorage.getItem("thsl_id");
        if (id) {
            return JSON.parse(id);
        }
    }
    return false;
};

export const logout = (next: () => void) => {
    if (typeof window !== "undefined") {
        sessionStorage.removeItem("thsl_token");
        sessionStorage.removeItem("thsl_user");
        sessionStorage.removeItem("thsl_email");
        sessionStorage.removeItem("thsl_id");
    }
    next();
};
